export const GET_ALL_CURRENCIES = 'GET_ALL_CURRENCIES';


